<template>
  <div style="margin-bottom:50px">	 
	 <van-sticky :offset-top="0" >
  		<van-notice-bar style="height:46px" background="#0076bf"   color='#fff'  left-icon="location-o">
			  <span v-if='isPosition' @click="toPosition" slot="default">{{phonePosition.address}}</span>
			  <van-loading v-else size="12px" color='#fff'><span  style='color:#fff'>正在定位...</span></van-loading>
			  <van-icon slot="right-icon" name="scan" size='20px' style="padding-left:15px"  @click='toScan'/>
		  </van-notice-bar>
		<van-icon name="scan" slot="right" size='20px' />
	</van-sticky>
	 <van-sticky :offset-top="46" >
  		<van-notice-bar background="#ededed"  color='#0076bf'   mode="link" @click="weatherPopShow ">
			温度 {{nowWeather.temperature}}℃, {{nowWeather.weather_info}}, {{nowWeather.wind_direction}},湿度:{{nowWeather.humidity}}%
		</van-notice-bar>
	</van-sticky>
	 <div>
		 <van-pull-refresh v-model="isLoading" @refresh="onRefresh">

		<van-swipe  indicator-color="white" >
		<van-swipe-item @click='toDataStatistics'>
			<p style="font-size:12px;padding:5px 0;text-align:center">{{chartArr.year}}年月平均温度(℃)</p>
			<div class='antV_charts' style="width:100%">
       			<canvas id="charts_tem" style="width:100%;height:300px"></canvas>
     		</div>
		</van-swipe-item>
		<van-swipe-item @click='toDataStatistics'>
			<p style="font-size:14px;padding:5px 0;text-align:center">{{chartArr.year}}年月累计雨量(mm)</p>
			<div class='antV_charts' style="width:100%">
       			<canvas id="charts_rain" style="width:100%;height:300px"></canvas>
     		</div>
		</van-swipe-item>
		<van-swipe-item @click='toDataStatistics'>
			<p style="font-size:14px;padding:5px 0;text-align:center">{{chartArr.year}}年月累计积温(℃)</p>
			<div class='antV_charts' style="width:100%">
       			<canvas id="charts_acc" style="width:100%;height:300px"></canvas>
     		</div>
		</van-swipe-item>		
	</van-swipe>
	<van-grid clickable square :column-num="4">		
        <van-grid-item v-for="(item,index) in gridList" :key='index' @click='gridClick(index)'>
            <img :src="item.url" width="60" alt="" srcset="">			
            <p class='grid_txt'>{{item.name}}</p>
        </van-grid-item >
	</van-grid>
    <!-- 新农人 -->
    <van-panel style="margin-top: 5px;">
        <div class='van-cell van-panel__header' slot="header">
            <div style='width:100%;vertical-align:middle;'>
                <van-row>
                    <van-col span="6" ><van-icon name="fire" size='14px' color='#1890ff' /> 新农人</van-col>
                    <van-col span="1" offset="17"><van-icon @click="toNewsList" style="vertical-align:middle" name="arrow" size='16px' color='#1890ff' /></van-col>  
                </van-row>  
            </div>            
        </div>
        <div style="padding:10px 0;letter-spacing:1px" slot="default">
            <van-skeleton  title  avatar  :row="3"  :loading="artcleLoading">
            <div v-for="(item,index) in newsHot" :key='index' @click='toDetails(item)'>
                <van-row type="flex">
                    <van-col span="23"  offset="1"><p  class="van-ellipsis" style="font-size:15px;font-weight:bold;line-height:32px;margin-top:5px">{{item.title}}</p></van-col>                   
                </van-row>
                <van-row type="flex">
                     <van-col span="8"  offset="1"><img :src="webUrl+item.thumb" width='140' alt=""></van-col>
                     <van-col span="10"  offset="2">
                         <div class='content' >
                             {{item.content}}
                         </div>
                     </van-col>
                </van-row>
                
            </div>
        </van-skeleton>
        </div>        
    </van-panel>
    <!-- 水肥基地 -->
    <van-panel style="margin-top: 5px;padding-bottom: 50px;">
        <div class='van-cell van-panel__header' slot="header">
            <div style='width:100%;vertical-align:middle;'>
                <van-row>
                    <van-col span="12" ><van-icon name="fire" size='14px' color='#1890ff' /> 捷佳润水肥基地优选</van-col>
                    <van-col span="1" offset="11"><van-icon @click='toBaseList' style="vertical-align:middle" name="arrow" size='16px' color='#1890ff' /></van-col>  
                </van-row>  
            </div>            
        </div>
        <div style="padding:10px 0" slot="default">
            <van-swipe :width='250' :show-indicators="false">
                 <van-swipe-item v-for="(item, index) in sourceHot" @click="toTrace(item)" :key="index">
                     <div style="padding-left:15px;line-height:20px">
                        <img style="border-radius:5px" :src="webUrl+item.product_img" width="200" height='160' alt="" srcset="">                        
                            <p style='font-size: 20px;'>{{item.node}}</p>
						    <p>{{item.name}}</p>
						    <p><span class="text-red">{{item.price}}</span>元/斤</p>                        
                     </div>
                     
                 </van-swipe-item>
            </van-swipe>
        </div>        
    </van-panel>
	</van-pull-refresh>
	</div>     
	 <div id="container" style="height:1px" v-show="false"></div>	
	



    
  </div>
</template>

<script>
// @ is an alias to /src
var Amap
const F2 = require('@antv/f2/lib/index')
const Tooltip = require('@antv/f2/lib/plugin/tooltip');
import gcoord from 'gcoord'
import {getWeatherCharts,getNewsHot,getSourceHot} from '@/request/data'
import {mapState,mapMutations} from 'vuex'
export default {	
  name: 'index',
  components: {
    
  },
  data() {
    return {
		artcleLoading:true,
		isLoading: false,        
		weatherPop: false,		
		positionInfo:{
			lat:'22.8653',
			lon:'108.285687',
			address:''
		},
		chartData:[],
		gridList:[
			{url:require('../../../static/plant.png'),name:'种植选址'},
			{url:require('../../../static/formula.png'),name:'测土配方'},
			{url:require('../../../static/order.png'),name:'水肥订购'},
			{url:require('../../../static/loan.png'),name:'佳农贷'},
		],
		chartArr:{
			year:'',
			acc_charts:[],
			rain_charts:[],
			tem_charts:[]
        },
        webUrl:this.$store.state.imgURL,
        newsHot:[],
		sourceHot:[],
		weatherArr:[],
		nowWeather:[],	
    }
  },
  computed: {
	...mapState(['phonePosition','isPosition']),
  },
  mounted() {
	
	this.getPoint()
	this.getWeatherForecast()
  },
  methods: {
	...mapMutations(['setPhonePosition','setIsPosition']),
	onRefresh(){
		this.setIsPosition(false)
		this.getPoint()
	},
	getWeatherCharts(){		
    	getWeatherCharts(this.phonePosition).then(res=>{
			if (res.data.code == 0) {
				this.chartData = res.data.data				
				this.dataChart()
			}
    	})
	},
	getWeatherForecast(){//天气预报
		let _that = this
		$.ajax({
			url: 'https://weather.jjr.vip/weather/forecast/getweather.html',
			type: 'post',
			dataType: "jsonp",
			jsonp:'callback',
			data:{
				lat:_that.phonePosition.lat,
				lng:_that.phonePosition.lon
			},
			jsonpCallback:'jjrcallback',
			success: function (r) {
				if (r.status == 1) {
					_that.weatherArr = r
					_that.nowWeather = r.nowData					
				}
			}
		}); 	
			
	},
	// jjrcallback(d){
		
	// },
	getPoint(){//定位		
		this.getNewsHot()
		this.getSourceHot()
		
		Amap = new AMap.Map("container", {
			resizeEnable: true
		});
		let _that = this	

		if(!this.isPosition){//判断是否刚打开需要定位
			Amap.plugin('AMap.Geolocation', function () {
				let geolocation = new AMap.Geolocation({
					// 是否使用高精度定位，默认：true
					enableHighAccuracy: true,
					// 设置定位超时时间，默认：无穷大
					timeout: 10000,					
				})	
				// geolocation.getCurrentPosition()
				// AMap.event.addListener(geolocation, 'complete', _that.onComplete)
				// AMap.event.addListener(geolocation, 'error', _that.onError)
				Amap.addControl(geolocation);
	        	geolocation.getCurrentPosition(function(status,result){
	            	if(status=='complete'){
	                	_that.onComplete(result);
	            	}else{
	                	_that.onError(result);
	            	}
	        	});
			}) 	
		}else{
			this.getWeatherCharts()
			this.getNewsHot()
			this.getSourceHot()
			this.getWeatherForecast()			
		}
		
		
	},
	onComplete(d){//定位成功结果		
		let data = {}
		data.lon = d.position.lng
		data.lat = d.position.lat
		data.address = d.formattedAddress
		this.setPhonePosition(data)
		this.setIsPosition(true)
		this.positionInfo.lon = d.position.lng
		this.positionInfo.lat = d.position.lat
		this.positionInfo.address = d.formattedAddress
		this.getWeatherCharts()
		

		// this.$dialog.alert({
		// 	message: JSON.stringify(d)
		// })

		console.log(data)
	},
	onError(data){//定位失败结果
		//h5+定位
		let _that = this
		
		this.mui.plusReady( () =>{
			let map = new plus.maps.Map("container");
			
			map.getUserLocation( function ( state, point ){			
				if( 0 == state ){
					let gps = [point.longitude,point.latitude]

					

					let geocoder = new AMap.Geocoder({
						city: "全国", //城市设为北京，默认：“全国”
						radius: 1000 //范围，默认：500
					});
					
					let newPoint = AMap.convertFrom(gps, 'baidu', function (status, result) {
						if (result.info === 'ok') {
							let lnglats = result.locations;
							geocoder.getAddress([lnglats[0].lng,lnglats[0].lat], function(status, result) {
								if (status === 'complete'&&result.regeocode) {
									let address = result.regeocode.formattedAddress;
									let data = {}
									data.lon = lnglats[0].lng
									data.lat = lnglats[0].lat
									data.address = address									
									_that.setPhonePosition(data)
									_that.setIsPosition(true)
									console.log(address)
								}else{
									_that.$toast('根据经纬度查询地址失败')
								}
							});
							_that.getWeatherCharts()
							_that.getNewsHot()
							_that.getSourceHot()
							_that.$toast.clear()
						}
					});

					// _that.$dialog.alert({
					// 			message: JSON.stringify(lnglats)
					// 		})
					
				}else{
					let data = {}
					data.lon = 108.279286
					data.lat = 22.859621
					data.address = '定位失败'
					_that.setPhonePosition(data)
					_that.setIsPosition(true)
					_that.$dialog.alert({
						message: '定位失败,请手动选择定位'
					})
				}
			} );
		})	
	},
    dataChart(){
		this.chartArr.year =  this.chartData.time[0].toString().slice(0,4);//年份
		this.chartArr.acc_charts = []
		this.chartArr.rain_charts = []
		this.chartArr.tem_charts = []
        for (let i = 0; i < this.chartData.time.length; i++) {
			//月份
			let time = this.chartData.time[i].toString().slice(4)+'月'

			//acc图表
			let acc ={}
			acc.time = time
			acc.data = this.chartData.acc[i]
			// acc.value = this.chartData.acc[i]
			this.chartArr.acc_charts.push(acc)

			//rain图表
			let rain ={}
			rain.time = time
			rain.data = this.chartData.rain[i]
			// rain.value = this.chartData.rain[i]
			this.chartArr.rain_charts.push(rain)

			//tem图表
			let tem ={}
			tem.time = time
			tem.data = this.chartData.tem[i]
			// tem.value = this.chartData.tem[i]
			this.chartArr.tem_charts.push(tem)
			// console.log(this.chartData.time[i])			
		}
		this.addAcc()
		this.addRain()
		this.addTem()
	},
	addAcc(){
		let chart = new F2.Chart({
			id: 'charts_acc',
			pixelRatio: window.devicePixelRatio
		});		
		chart.tooltip(false);
		chart.source(this.chartArr.acc_charts);
		
		this.chartArr.acc_charts.map(function(obj) {
			chart.guide().text({
			position: [obj.time, obj.data],
			content: obj.data,
			style: {
				textBaseline: 'bottom',
				textAlign: 'center'
			},
			offsetY: -2
			});
		});		
		chart.line().position('time*data').shape('smooth').color('l(0) 0:#70cdd0 1:#1890ff');
		chart.area().position('time*data').shape('smooth').color('l(0) 0:#70cdd0 1:#1890ff');
		chart.render();

	},
	addRain(){
		let chart = new F2.Chart({
			id: 'charts_rain',
			pixelRatio: window.devicePixelRatio
		});		
		chart.tooltip(false);
		chart.source(this.chartArr.rain_charts);
		this.chartArr.rain_charts.map(function(obj) {
			chart.guide().text({
			position: [obj.time, obj.data],
			content: obj.data,
			style: {
				textBaseline: 'bottom',
				textAlign: 'center'
			},
			offsetY: -2
			});
		});
				
		chart.line().position('time*data').shape('smooth').color('l(0) 0:#70cdd0 1:#1890ff');
		chart.area().position('time*data').shape('smooth').color('l(0) 0:#70cdd0 1:#1890ff');
		chart.render();

	},
	addTem(){
		

		let chart = new F2.Chart({
			id: 'charts_tem',
			pixelRatio: window.devicePixelRatio
		});		
		chart.tooltip(false);
		chart.source(this.chartArr.tem_charts);
		this.chartArr.tem_charts.map(function(obj) {
			chart.guide().text({
			position: [obj.time, obj.data],
			content: obj.data,
			style: {
				textBaseline: 'bottom',
				textAlign: 'center'
			},
			offsetY: -2
			});
		});
				
		chart.line().position('time*data').shape('smooth').color('l(0) 0:#70cdd0 1:#1890ff');
		chart.area().position('time*data').shape('smooth').color('l(0) 0:#70cdd0 1:#1890ff');
		chart.render();

	},
	gridClick(index){
		switch (index) {
			case 0:
                this.$router.push({name:'plantingSite'});				
				break;
			case 1:
                this.$router.push({name:'soilFormula'});
                
				
				break;
			case 2:
				this.$toast('请联系客服购买');
				break;
			case 3:
				this.$toast('业务筹备中，敬请期待');
				break;
			default:
				break;
		}
    },
    getNewsHot(){//新闻
        getNewsHot().then(res=>{
            if (res.data.code == 0) {
                this.newsHot = res.data.data
                this.artcleLoading = false
            }
            
        })
    },
    getSourceHot(){//基地
        getSourceHot().then(res=>{
            if (res.data.code == 0) {
                this.sourceHot = res.data.data
            }            
		})
		this.$toast.clear()
		this.isLoading=false
	},
	weatherPopShow(){
		this.$router.push({name:'forecast',params:{weatherArr:this.weatherArr}});
	},
    toNewsList(){
        this.$router.push({name:'newsList'});        
    },
    toBaseList(){
        this.$router.push({name:'baseList'});        
    },
    toDetails(item){        
        this.$router.push({name:'articleDetails',query:{id:item.id}});
    },
    toTrace(item){        
        this.$router.push({name:'traceability',query:{id:item.id}});
    },
    toDataStatistics(){
        this.$router.push({name:'dataStatistics',query:{lat:this.phonePosition.lat,lon:this.phonePosition.lon}});
	},
	toPosition(){
		this.$router.push({name:'position'});  
	},
	toScan(){
		this.$router.push({name:'scan'})
	}
	
	


	

  },
}
</script>
<style scoped>
.grid_txt{margin-top: 8px;color: #7d7e80;font-size: 12px;word-wrap: break-word;}
.content{line-height:20px;font-size:12px;color:#000000a6;height:60px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;　-webkit-line-clamp:2;　-webkit-box-orient:vertical;}
.text-red{color:#f00}
</style>










